import React, { useContext, useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import Modal from '@components/Modal'
import { client } from '@utils/client'
import EmptySvg from '@image/icons/EmptySvg'
import {
  getStatusWellKidzClubMember,
  wellKidzClubButton,
  wellKidzClubMember,
} from './List'
import Text from '@components/Text'
import { ThemeContext } from '@contexts/ThemeContext'
import { Button, Col, Row, Space } from 'antd'
import dayjs from 'dayjs'
const DetailMember = (props) => {
  const {
    open,
    setOpen,
    id,
    wellClubId,
    unsuspendAccount,
    setConfirm,
    dataMember,
  } = props
  const { t } = useLocalization()
  const { theme } = useContext(ThemeContext)
  const [memberData, setMemberData] = useState({ profile: {} })
  const [history, setHistory] = useState({ coupon_history: [] })
  const [page, setPage] = useState(1)
  const [limit] = useState(10)
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const listContainerRef = useRef(null)

  useEffect(() => {
    if (id) {
      fetchMemberData(id)
      resetAndFetchHistory()
    }
  }, [id])

  const fetchMemberData = async (id) => {
    try {
      const response = await client.get(`/wellkidzclub/user/me/${id}`)
      setMemberData(response.data)
    } catch (e) {
      console.error('Error fetching member data:', e)
    }
  }

  const fetchHistory = async (pageToLoad) => {
    if (!hasMore || loading) return
    setLoading(true)
    try {
      const response = await client.get(`/coupons/wellkidzclub/${id}/history`, {
        params: { limit: limit, page: pageToLoad },
      })
      const newItems = response.data.coupon_history || []
      setHistory((prev) => ({
        coupon_history: [...(prev.coupon_history || []), ...newItems],
      }))
      setHasMore(newItems.length === limit)
      setPage((prev) => prev + 1)
    } catch (e) {
      console.error('Error fetching history:', e)
    } finally {
      setLoading(false)
    }
  }

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
    if (bottom) {
      fetchHistory(page)
    }
  }

  const resetAndFetchHistory = () => {
    setHistory({ coupon_history: [] })
    setPage(1)
    setHasMore(true)
    fetchHistory(1)
  }

  const calculateAge = (birthdate) => {
    return dayjs().diff(dayjs(birthdate), 'year')
  }
  /**
   * @type {{
   * footer: React.CSSProperties
   * body: React.CSSProperties
   * header: React.CSSProperties
   * bodyModalStyle: React.CSSProperties
   * btn: React.CSSProperties
   * list: React.CSSProperties
   * listDetail: React.CSSProperties
   * listContainer: React.CSSProperties
   * }}
   */

  const style = {
    header: {},
    body: { display: 'flex', flexDirection: 'column', gap: 16 },
    bodyModalStyle: {
      display: 'flex',
      flexDirection: 'column',
      padding: 16,
      overflowY: 'hidden',
      gap: 16,
      maxHeight: 700,
    },
    footer: {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: 24,
      gap: 8,
    },
    empty: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      height: 200,
    },
    btn: {
      borderRadius: '8px',
      width: '170px',
      height: '40px',
      backgroundColor: theme.vermilion,
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '8px 16px',
      border: `1px solid ${theme.grey}`,
      borderRadius: 16,
      minHeight: 80,
    },
    listDetail: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'scroll',
      gap: 8,
      maxHeight: 300,
    },
  }

  return (
    <>
      <Modal
        // title={`${firstname} ${lastname}`}
        centered={false}
        open={open}
        onCancel={() => setOpen(false)}
        closable={true}
        maskClosable={false}
        // footer={null}
        width={550}
        // style={{ top: 20 }}
        bodyStyle={style.bodyModalStyle}
      >
        <div style={style.header}>
          <Text level={1} strong>
            {`${memberData.profile.firstname} ${memberData.profile.lastname}`}
          </Text>
        </div>
        <div style={style.body}>
          <Space direction="vertical">
            <Row>
              <Col flex={'120px'}>
                <Text level={3} color={theme.text.darkGrey}>
                  {t(`${wellKidzClubMember}.age`)} :
                </Text>
              </Col>
              <Col flex={'auto'}>
                <Text level={3}>
                  {calculateAge(memberData.profile.birthdate)}{' '}
                  {t(`${wellKidzClubMember}.yaer`)}
                </Text>
              </Col>
            </Row>
            <Row>
              <Col flex={'120px'}>
                <Text level={3} color={theme.text.darkGrey}>
                  {t(`${wellKidzClubMember}.hospitalNo`)} :
                </Text>
              </Col>
              <Col flex={3}>
                <Text level={3}>
                  {dataMember.hns.length > 0 ? dataMember.hns[0] : '-'}
                </Text>
              </Col>
            </Row>
            <Row>
              <Col flex={'120px'}>
                <Text level={3} color={theme.text.darkGrey}>
                  {t(`${wellKidzClubMember}.id`)} :
                </Text>
              </Col>
              <Col flex={3}>
                <Text level={3}>{memberData.profile.id}</Text>
              </Col>
            </Row>
            <Row>
              <Col flex={'120px'}>
                <Text level={3} color={theme.text.darkGrey}>
                  {t(`${wellKidzClubMember}.expDate`)} :
                </Text>
              </Col>
              <Col flex={3}>
                <Text level={3}>
                  {dayjs(memberData.expiredAt).format('DD MMM YYYY')}
                </Text>
              </Col>
            </Row>
            <Row>
              <Col flex={'120px'}>
                <Text level={3} color={theme.text.darkGrey}>
                  {t(`${wellKidzClubMember}.status.label`)} :
                </Text>
              </Col>

              <Col flex={3}>
                <Text level={3}>
                  {getStatusWellKidzClubMember(
                    memberData.statusAcc,
                    theme.text,
                    t
                  )}
                </Text>
              </Col>
            </Row>
          </Space>
          <Space direction="vertical">
            <div>
              <Text level={3}>{t(`${wellKidzClubMember}.eCouponHistory`)}</Text>
            </div>
            <div
              ref={listContainerRef}
              onScroll={handleScroll}
              style={style.listContainer}
            >
              {history.coupon_history.length > 0 ? null : (
                <div style={style.empty}>
                  <EmptySvg width={100} height={100} />
                  <Text level={3} bold>
                    {t(`${wellKidzClubMember}.noECouponData`)}
                  </Text>
                </div>
              )}

              {(history.coupon_history || []).map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      ...style.list,
                      marginRight: history.coupon_history.length > 3 ? 8 : 0,
                    }}
                  >
                    <Text
                      level={3}
                      strong
                      style={{}}
                      ellipsis={{ tooltip: item.coupon_name }}
                    >
                      {item.coupon_name}
                    </Text>
                    <div style={style.listDetail}>
                      <Text>{t(`${wellKidzClubMember}.eCouponUsageDate`)}</Text>
                      <Text style={{ fontWeight: '600' }}>
                        {dayjs(item.usedAt).locale('th').format('DD MMMM YYYY')}
                      </Text>
                    </div>
                  </div>
                )
              })}
              {loading && (
                <div style={{ textAlign: 'center', padding: 8 }}>
                  <Text level={3}>{t('กำลังโหลด...')}</Text>
                </div>
              )}
            </div>
          </Space>
        </div>
        {/* BANNED */}
        <div style={style.footer}>
          {memberData.statusAcc === 'BANNED' ? (
            <Button
              key="unsuspendAccount"
              onClick={() => unsuspendAccount(wellClubId)}
              style={{ ...style.btn, backgroundColor: theme.primary }}
            >
              <Text level={3} color={theme.text.white} strong>
                {t(`${wellKidzClubButton}.unsuspendAccount`)}
              </Text>
            </Button>
          ) : (
            <Button
              key="suspendAccount"
              onClick={() => setConfirm(true)}
              style={style.btn}
            >
              <Text level={3} color={theme.text.white} strong>
                {t(`${wellKidzClubButton}.suspendAccount`)}
              </Text>
            </Button>
          )}
        </div>
      </Modal>
    </>
  )
}

DetailMember.propTypes = {
  defaultValues: PropTypes.object,
  dataMember: PropTypes.object,
  id: PropTypes.string.isRequired,
  wellClubId: PropTypes.string.isRequired,
  setConfirm: PropTypes.func,
  unsuspendAccount: PropTypes.func,
  setOpen: PropTypes.func,
  open: PropTypes.bool,
}

export default DetailMember
